import { QuoteStatus } from "@/gql/graphql";
import { BadgeColor } from "@/components/catalyst/badge";

export const quoteStatusColorMap: Record<QuoteStatus, BadgeColor> = {
  [QuoteStatus.Invoiced]: "green",
  [QuoteStatus.Expired]: "red",
  [QuoteStatus.Voided]: "red",
  [QuoteStatus.Draft]: "zinc",
  [QuoteStatus.Accepted]: "sky",
  [QuoteStatus.Rejected]: "red",
  [QuoteStatus.Issued]: "yellow",
};
